export default __webpack_public_path__ + "static/media/0d7e38800b795dbe5b9381fe3ad9fde8.png";